const SelectedLotInfo = ({ lot }: { lot: any }) => {
  if (!lot) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "20px",
        background: "white",
        padding: "12px 16px",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        zIndex: 200,
      }}
    >
      <div>
        <strong>지번:</strong> {lot.jibun}
      </div>
      <div>
        <strong>PNU:</strong> {lot.pnu}
      </div>
      <div>
        <strong>면적정보:</strong> {lot.bchk}
      </div>
      <div>
        <strong>행정코드:</strong> {lot.region_code}
      </div>
    </div>
  );
};
export default SelectedLotInfo;
